export const downloadPDF = ({
  base64Data,
  filename,
}: {
  base64Data: string
  filename: string
}) => {
  // Decode base64 string to binary data
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length)
    .fill(0)
    .map((_, i) => byteCharacters.charCodeAt(i))
  const byteArray = new Uint8Array(byteNumbers)

  // Create a Blob with the PDF MIME type
  const blob = new Blob([byteArray], { type: 'application/pdf' })

  // Create a link and trigger download
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = filename
  document.body.appendChild(link)
  link.click()

  // Cleanup
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}
